import { render, staticRenderFns } from "./ColourDataV2.vue?vue&type=template&id=15e66fed&"
import script from "./ColourDataV2.vue?vue&type=script&lang=js&"
export * from "./ColourDataV2.vue?vue&type=script&lang=js&"
import style0 from "./ColourDataV2.vue?vue&type=style&index=0&id=15e66fed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports